/*
 * @Author: ZHANGJIAN
 * @Date: 2021-10-20 16:40:02
 * @LastEditTime: 2021-12-13 17:20:52
 * @LastEditors: ZHANGJIAN
 * @Description:
 */
Vue.component("date-picker", {
  props: {
    //这里是组件可以接受的参数，也就是相当于面向原型写组件时的配置参数，用户可以传递不同参数，自己定义组件
    title: {
      //卡片标题
      type: String,
      default: "",
    },
    value: {
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      isMobile: false,
      date: "",
    };
  },
  template: `
      <div class="modal">
        <template v-if="isMobile">
        <input placeholder="請選擇日期" type="text" v-model="date" id="date" readonly>
        </template>
        <template v-else>
        <input placeholder="請選擇日期" type="text" v-model="date" id="date" readonly>
        </template>
          {{this.title}}
      </div>
  `,

  mounted() {
    let _self = this;
    this.isMobile = this.$root.isMobile() || false;
    //這邊分為移動端和pc端兩個時間控件
    if (isMobile) {
      var jd = new Rolldate({
        el: "#date",
        format: "YYYY-MM-DD",
        beginYear: 2020,
        endYear: new Date().getFullYear(),
        minStep: 1,
        lang: {
          title: "選擇日期",
          cancel: "重置",
          confirm: "確認",
        },
        trigger: "tap",
        init: function () {},
        moveEnd: function () {},
        confirm: function (date) {
          _self.date = date;
          _self.emitValue(date);
        },
        cancel: function () {
          _self.date = "";
          _self.emitValue("");
        },
      });
      // jd.show();
      // jd.hide();
    } else {
      jeDate("#date", {
        //日期 中文 语言设置
        language: {
          name: "tw",
          month: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          weeks: ["日", "一", "二", "三", "四", "五", "六"],
          times: ["小时", "分钟", "秒数"],
          timetxt: ["時間選擇", "開始時間", "結束時間"],
          backtxt: "返回日期",
          clear: "清空",
          today: "現在",
          yes: "確定",
        },
        theme: { bgcolor: "#fff", color: "#42b1f1", pnColor: "#a9a9a9" },
        format: "YYYY-MM-DD",
        onClose: false,
        maxDate: dateFormat(),
        donefun: function (elem, value) {
          _self.date = elem.val;
          _self.emitValue(elem.val);
        },
        clearfun: function (elem, value) {
          _self.date = "";
          _self.emitValue("");
        },
      });
    }

    // jeDate("#test",{
    //   format:"YYYY-MM-DD",
    //   isTime:false,
    //   minDate:"2014-09-19 00:00:00"
    // })
  },
  methods: {
    //给父组件传值
    emitValue(val) {
      this.$emit("input", val);
    },
  },
});
